import {
  deleteEngageTaskSchedule,
  getEngageTaskSchedule,
  postEngageTaskSchedule,
  putEngageTaskSchedule,
} from '../crud/engage.crud'
import useApiControls from './useApiControls'

const INITIAL_DATA = []

const useEngageTaskScheduling = () => {
  const postControls = useApiControls({ api: postEngageTaskSchedule })

  const putControls = useApiControls({ api: putEngageTaskSchedule })

  const deleteControls = useApiControls({ api: deleteEngageTaskSchedule })

  const getControls = useApiControls({ api: getEngageTaskSchedule, initialData: INITIAL_DATA })

  return {
    // post
    scheduleEngageTask: postControls.callApi,
    isSchedulingEngageTask: postControls.loading,
    errorSchedulingEngageTask: postControls.error,
    successSchedulingEngageTask: postControls.success,
    resetSchedulingControls: postControls.reset,

    // put
    updateScheduledTask: putControls.callApi,
    isUpdatingScheduledTask: putControls.loading,
    errorUpdatingScheduledTask: putControls.error,
    successUpdatingScheduledTask: putControls.success,
    resetUpdateTaskControls: putControls.reset,

    // delete
    deleteScheduledTask: deleteControls.callApi,
    isDeletingScheduledTask: deleteControls.loading,
    errorDeletingScheduledTask: deleteControls.error,
    successDeletingScheduledTask: deleteControls.success,
    resetDeleteTaskControls: deleteControls.reset,

    // get
    fetchScheduledEngageTasks: getControls.callApi,
    isFetchingScheduledTasks: getControls.loading,
    errorFetchingScheduledTasks: getControls.error,
    scheduledEngageTasks: getControls.data,
  }
}

export default useEngageTaskScheduling
